import {createBrowserRouter, useParams, Navigate} from 'react-router-dom';
import Login from './pages/login/signIn/Login';
import SignUp from './pages/login/signUp/SignUp';
import ViewSymbols from './component/ViewSymbols';
import ProtectedRoute from './ProtectedRoute';
import Layout from './layout/Layout';
import RootLayout from './layout/RootLayout';
import VerifyScreen from './pages/package/componnent/verifyScreen/VerifyScreen';
import RouteComponent from './components/RouteComponent/RouteComponent';
import SuspendedConfirmation from './pages/suspendedConfirmation/suspendedConfirmation';
import {useSelector} from 'react-redux';
import {loginLoader} from './pages/login/signIn/Login.loader';
import {suspendedConfirmationLoader} from './pages/suspendedConfirmation/suspendedConfirmation.loader';
// import {subscriptionLoader} from './pages/subscriptions/subscription.loader';
import {initAxios} from './library/axios';
import {RootState} from './redux/store.type';
import {DELIVERY_TYPES, MESSAGE_TYPES} from './pages/branding/menu/brandingConfig';
import ReactShareDemo from './pages/reactShareDemo/ReactShareDemo';

// Helper components for redirects - defined before router
const PidRedirect = () => {
    const {pid} = useParams();
    return <Navigate to={`/p/${pid}/home`} replace />;
};

const EidRedirect = () => {
    const {eid} = useParams();
    return <Navigate to={`/e/${eid}/realtime`} replace />;
};

const BrandingRedirect = () => {
    const {eid, page} = useParams();
    return <Navigate to={`/e/${eid}/${page}/branding/${MESSAGE_TYPES.sendTicket}/${DELIVERY_TYPES.whatsapp}`} replace />;
};

const BrandingMessageTypeRedirect = () => {
    const {eid, page, messageType} = useParams();
    return <Navigate to={`/e/${eid}/${page}/branding/${messageType}/${DELIVERY_TYPES.whatsapp}`} replace />;
};

const RootRedirect = () => {
    const {defaultPid, defaultEid} = useSelector((state: RootState) => state.user);
    return <Navigate to={getDefaultPath(defaultPid, defaultEid)} replace />;
};
initAxios();
export const getDefaultPath=(defaultPid,defaultEid)=>defaultPid?`/p/${defaultPid}/home`:defaultEid?`/e/${defaultEid}/realtime`:'login';
// Create the router with data router capabilities
export const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        children: [
            {index: true, element: <RootRedirect />},
            {path: 'login/forgetPassword', element: <Login pageType="resetPassword" />},
            {path: 'login', element: <Login />, loader: loginLoader},
            {path: 'signUp', element: <SignUp />},
            {path: 'viewSymbols', element: <ViewSymbols />},
            {path: 'suspendedConfirmation', element: <SuspendedConfirmation />, loader: suspendedConfirmationLoader},
            {path: 'reactShareDemo', element: <ProtectedRoute><ReactShareDemo /></ProtectedRoute>},
            {path: 'p/:pid', element: <ProtectedRoute><Layout /></ProtectedRoute>,
                children: [
                    {index: true, element: <PidRedirect />},
                    {path: 'packageVerification', element: <VerifyScreen />},
                    {path: ':page', element: <RouteComponent />},
                    {path: ':page/:subPage', element: <RouteComponent />},
                    {path: ':page/:subPage/:pageId', element: <RouteComponent />},
                    {path: ':page/branding', element: <BrandingRedirect />},
                    {path: ':page/branding/:messageType', element: <BrandingMessageTypeRedirect />},
                    {path: ':page/:subPage/:messageType', element: <RouteComponent />},
                    {path: ':page/:subPage/:messageType/:deliveryType', element: <RouteComponent />}
                ]
            },
            {
                path: 'e/:eid', element: <ProtectedRoute><Layout /></ProtectedRoute>,
                children: [
                    {index: true, element: <EidRedirect />},
                    // {path: 'subscription', element: <RouteComponent />, loader: subscriptionLoader},
                    {path: ':page', element: <RouteComponent />},
                    {path: ':page/:subPage', element: <RouteComponent />},
                    {path: ':page/:subPage/:pageId', element: <RouteComponent />},
                    {path: ':page/branding', element: <BrandingRedirect />},
                    {path: ':page/branding/:messageType', element: <BrandingMessageTypeRedirect />},
                    {path: ':page/:subPage/:messageType', element: <RouteComponent />},
                    {path: ':page/:subPage/:messageType/:deliveryType', element: <RouteComponent />}
                ]
            },
        ]
    }
]);

